<template>
  <div
    v-block-loading:initFetch="loading"
    v-loading.fullscreen="showLoading"
    :class="['m-live-commentary',{'has-back':!loading}]"
  >
    <template v-if="!loading">
      <!-- 有内容时 -->
      <template v-if="liveCommentaryList.length">
        <!-- new message 关闭自动刷新 -->
        <div
          v-if="hasNewMessage"
          class="live-commentary-new-message"
          @click="getNewMessage"
        >
          <span>New Messages</span>
        </div>

        <!-- new message 浮层版未关闭-->
        <div
          v-if="hasNew"
          class="live-commentary-new-tip"
          @click="handleScrollTop"
        >
          <span>New Messages</span>
        </div>

        <!--  message -->
        <template v-for="(item,index) in liveCommentaryList">
          <MsgFrame
            v-if="item.moduleType !== 5"
            :key="item.id"
            :commentary-type="item.commentaryType"
            :match-clock="item.commentaryText[0].matchClock"
            :team="item.commentaryText[0].team"
            :default-visible="item.moduleType !== 3"
            :is-push-msg="item.isPushMsg"
          >
            <template v-if="getMsgComponentName(item.moduleType)">
              <component
                :is="getMsgComponentName(item.moduleType)"
                :data="getMsginfo(item)"
                :has-new="hasNew"
              />
            </template>
          </MsgFrame>

          <!-- 分割线 -->
          <div
            v-if="!commentarySubStatus&&dividerIndex&&dividerIndex===index"
            :key="index"
            class="live-commentary-divider"
          >
            <div class="live-commentary-divider-main">
              <p>Location of Last update</p>
            </div>
          </div>
        </template>

        <div
          v-if="HistoryNoMore || isAjax"
          class="live-commentary-no-more"
        >
          <p v-if="isAjax">
            loading...
          </p>
          <p v-else>
            No More Records
          </p>
        </div>

        <!-- 底部浮层 -->
        <MsgFixSuspended
          v-if="show"
          :value="value"
        />

        <!-- 刷新按钮 -->
        <div
          v-if="!commentarySubStatus"
          class="live-commentary-refresh"
          @click="handleRefresh()"
        >
          <svg-icon
            icon-class="icon-refresh-ring"
            :class="{'rotate':isRefresh}"
          />
        </div>
      </template>

      <!-- 无内容时 -->
      <template v-if="!liveCommentaryList.length">
        <Empty text="No content at present, waiting for the start of the match." />
      </template>

      <!-- suspended状态 -->
      <Broadcast v-if="liveCommentaryStatus ===2" />

      <!-- 动画消息 test -->
      <MsgAnimation v-show="showAnime" />

      <audio ref="score_change">
        <source
          src="~assets/audio/score-change.mp3"
          type="audio/mpeg"
        >
      </audio>
    </template>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { scrollToAnchor } from 'wap/utils/scrollToAnchor.js'
import { checkLastestCommentary } from '@ms/stores/matchCommentary/api.js'
import Empty from 'wap/components/Empty/index.vue'
import eventBus from '@ms/utils/event-bus.js'
import MsgFrame from '../components/MsgFrame.vue'
import MsgText from '../components/MsgText.vue'
import MsgStatistic from '../components/MsgStatistic.vue'
import MsgVoucher from '../components/MsgVoucher.vue'
import MsgFixSuspended from '../components/MsgFixSuspended.vue'
import MsgAnimation from '../components/MsgAnimation.vue'
import MsgMarketContainer from '../components/MsgMarketContainer'
import Broadcast from '../components/Broadcast.vue'
import useDefaultMarket from 'composables/market/useDefaultMarket.js'

import 'base/icons/svg/refresh-ring.svg'

export default {
  name: 'Commentary',
  components: {
    MsgFrame,
    MsgText,
    MsgStatistic,
    MsgVoucher,
    MsgMarketContainer,
    MsgAnimation,
    MsgFixSuspended,
    Empty,
    Broadcast
  },
  setup() {
    const { getMarketInfo } = useDefaultMarket()

    const matchDetailStore = useMatchDetailStore()
    const {
      eventId,
      event,
      dividerIndex,
      liveCommentaryList,
      liveCommentaryStatus,
      liveCommentaryHasVouvher,
      liveRemainCount,
      commentaryMessagePool,
      commentarySubStatus,
      restartMessageShow,
      HistoryNoMore,
      commentaryAnimStatus
    } = storeToRefs(matchDetailStore)

    const { subCommentary, getCommentary, getCommentaryNewMessage, transformMessageFromPool, updateMessageShowStatus, resetLiveCommentary } = matchDetailStore

    return {
      getMarketInfo,
      eventId,
      event,
      dividerIndex,
      liveCommentaryList,
      liveCommentaryStatus,
      liveCommentaryHasVouvher,
      liveRemainCount,
      commentaryMessagePool,
      commentarySubStatus,
      restartMessageShow,
      HistoryNoMore,
      commentaryAnimStatus,
      subCommentary,
      getCommentary,
      getCommentaryNewMessage,
      transformMessageFromPool,
      updateMessageShowStatus,
      resetLiveCommentary
    }
  },
  data() {
    return {
      loading: false,
      commentaryType: 1,
      value: 0,
      show: false, // test: 底部浮层显示
      hasNewMessage: false, // 固定头部消息提示
      hasNew: false, // test: 浮窗消息提示
      isRefresh: false, // 请求刷新旋转
      liveCommentaryAll: [], // 所有消息
      isAjax: false, // 是否正在请求历史
      latestCommentaryId: '', // 最新的消息id
      showLoading: false,
      showAnime: false, // test: 动画显示
      checkLastTimer: ''
    }
  },
  watch: {
    commentarySubStatus(val) {
      if (!val) {
        this.getLatestId()
      } else {
        // 注意这里的定时器冲突，需要加 nextTick, 去掉会报错
        this.$nextTick(() => {
          // 关闭后又打开不请求中间消息，已与产品确认
          this.hasNewMessage = false
          clearInterval(this.checkLastTimer)
        })
      }
    },
    restartMessageShow(val) {
      if (val) {
        // 重启倒计时
        // live消息加入 判断滚动位置 是否需要 新消息提示
        this.judgeNewTipStatus()
        if (this._timer) clearTimeout(this._timer)
        this.startMessageShow()
        this.updateMessageShowStatus(false)
      }
    }
  },
  mounted() {
    this.initFetch()
    this.getMarketInfo({ sportId: this.event.sportId, withOthers: true })
    eventBus.$on('live_commentary_handleAnime', this.handleAnimate)
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy() {
    this.subCommentary({ isSub: false })
    this.resetLiveCommentary()
    window.removeEventListener('scroll', this.scrollListener)
    this.checkLastTimer && clearInterval(this.checkLastTimer)
  },
  methods: {
    judgeNewTipStatus() {
      // const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.$el) {
        const eleTop = this.$el.getBoundingClientRect().top
        if (eleTop <= 0) {
          this.hasNew = true
        }
      }
    },
    startMessageShow() {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        if (this.commentaryMessagePool.length) {
          this.transformMessageFromPool()
          // 自建消息添加，判断滚动位置是否需要显示 新消息提示
          this.judgeNewTipStatus()
        }
        return this.startMessageShow()
      }, 2000)
    },
    async initFetch() {
      this.loading = true
      try {
        await this.getCommentary()
        this.loading = false

        const eventId = this.$route.params.eventId || this.$route.query.e
        const id = eventId ? eventId.replace(/&(.+)?/, '') : ''
        // 由于切换页面 eventId未及时变更，所以判断为同一个才订阅；正常情况下是一致的
        if (id === this.eventId) {
          // 如果推送开关为打开则订阅
          if (this.commentarySubStatus) {
            this.subCommentary()
            this.startMessageShow() // 是否需要放在判断条件中
          } else {
            // 取消订阅，则定时查询
            this.getLatestId()
          }
        }
      } catch (e) {
        console.error(e)
        this.loading = -1
      }
    },
    getLatestId() {
      this.checkLastTimer = setInterval(this.checkLastestId, 60000)
    },
    async checkLastestId() {
      try {
        const data = await checkLastestCommentary(this.eventId)
        if (data.id) {
          this.latestCommentaryId = data.id
          if (!this.isRefresh) this.hasNewMessage = true
        }
      } catch (e) {
        console.error(e)
      }
    },
    async handleRefresh() {
      try {
        this.isRefresh = true
        this.showLoading = true
        clearInterval(this.checkLastTimer)
        await this.checkLastestId()
        if (this.latestCommentaryId) {
          await this.getNewMessage()
        }
        this.isRefresh = false
        this.showLoading = false
        this.getLatestId()
      } catch (e) {
        this.isRefresh = false
        this.showLoading = false
        this.getLatestId()
        console.error(e)
      }
    },
    async getNewMessage() {
      try {
        if (!this.latestCommentaryId && this.showLoading) {
          return false
        }
        this.showLoading = true
        const { latestCommentaryId } = this
        const { id } = this.liveCommentaryList[0]
        await this.getCommentaryNewMessage({ latestCommentaryId, lastCommentaryId: id })
        this.showLoading = false
        this.isRefresh = false
        this.latestCommentaryId = ''
        this.hasNewMessage = false // 请求后新消息提示消失
      } catch (e) {
        this.showLoading = false
        this.isRefresh = false
        console.error(e)
      }
    },
    getMsgComponentName(moduleType) {
      switch (moduleType) {
        case 1:
          return 'MsgText'
        case 2:
          return 'MsgStatistic'
        case 3:
          return 'MsgMarketContainer'
        case 4:
          return 'MsgVoucher'
        case 5:
          // Animation and Sounds动画和声音模块
          return ''
        default:
          return undefined
      }
    },
    handleAnimate() {
      // 判断用户是否关闭动画
      if (!this.commentaryAnimStatus || this.showAnime) return false
      this.triggerMusic('score_change')
      this.showAnime = true
      setTimeout(() => {
        this.showAnime = false
      }, 4000)
    },
    triggerMusic(name) {
      const audio = this.$refs[name]
      if (audio) {
        audio.play()
      }
    },
    getMsginfo(info) {
      const { commentaryText, moduleType, ...rest } = info
      const infoList = { moduleType, ...rest }
      if (moduleType === 2 || moduleType === 3) {
        infoList.commentaryText = commentaryText
      } else {
        infoList.commentaryText = commentaryText[0]
      }
      return infoList
    },
    test(idx) {
      this.value = idx
    },
    scrollListener() {
      // 滚动高度
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 可见高度
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // 内容高度
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollHeight === windowHeight) {
        return false
      }
      if (scrollHeight - windowHeight - scrollTop < 10 && !this.isAjax && !this.HistoryNoMore) {
        // 滑到底部请求接口
        this.isAjax = true
        this.getHistoryList()
      }
      if (this.$el.getBoundingClientRect().top > 20) {
        this.hasNew = false
      }
    },
    async getHistoryList() {
      try {
        await this.getCommentary()
        this.isAjax = false
      } catch (e) {
        this.isAjax = false
        console.error(e)
      }
    },
    handleScrollTop() {
      // 滚动到顶部
      scrollToAnchor(0)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-live-commentary {
  position: relative;
  // 限制 market 等溢出
  overflow: hidden;
  min-height: 50/@rem;
  padding: 15/@rem 0 90/@rem;

  &.has-back {
    background-color: @mask;
  }

  .m-empty-data {
    padding: 50/@rem 0;
  }

  .msg-frame:first-of-type {
    .msg-frame-left {
      &::before {
        background-color: @mask;
      }
    }
  }
}

.live-commentary {
  &-new-message {
    width: 310/360 * 100%;
    height: 30/@rem;
    border: 1px solid @primary;
    border-radius: 30/@rem;
    margin: 0 auto 25/@rem;
    color: @primary;
    font-size: 14/@rem;
    line-height: 30/@rem;
    text-align: center;

    span {
      position: relative;

      &::after {
        position: absolute;
        top: 0;
        right: -2/@rem;
        border: 3/@rem solid #ff3826;
        border-radius: 3/@rem;
        content: "";
      }
    }
  }

  &-new-tip {
    position: fixed;
    z-index: 2;
    top: 50/@rem;
    right: 0;
    left: 0;
    width: 162/360 * 100%;
    height: 30/@rem;
    border: 1px solid @primary;
    border-radius: 30/@rem;
    margin: auto;
    background-color: rgba(51, 51, 51, 90%);
    color: @primary;
    font-size: 14/@rem;
    line-height: 30/@rem;
    text-align: center;

    span {
      position: relative;

      &::before,
      &::after {
        position: absolute;
        content: "";
      }

      &::before {
        top: 1px;
        right: -8px;
        width: 6px;
        height: 6px;
        box-sizing: border-box;
        border: 3px solid transparent;
        border-top: none;
        border-bottom: 6px solid @green;
      }

      &::after {
        top: 7px;
        right: -6px;
        width: 2px;
        height: 7/@rem;
        background-color: @green;
      }
    }
  }

  &-refresh {
    position: fixed;
    z-index: 5;
    right: 6px;
    bottom: 165px;
    display: flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 36px;
    background-color: @white;
    transition: bottom 0.3s linear;

    .svg-icon {
      color: @major;
      font-size: 18px;

      &.rotate {
        animation: rotate 1s linear infinite;
      }
    }
  }

  &-divider {
    position: relative;
    width: 330/360 * 100%;
    box-sizing: border-box;
    padding: 20/@rem 0 12/@rem 12/@rem;
    margin: 0 auto;
    background-color: @mask;

    &::before {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 12/@rem;
      width: 1px;
      height: 100%;
      background-color: #222;
      content: "";
    }

    &-main {
      position: relative;
      display: flex;
      // margin-left: 12/@rem;
      width: 100%;
      height: 30/@rem;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      color: @gray;

      &::before {
        position: absolute;
        z-index: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        margin: auto;
        background-color: #979797;
        content: "";
      }
    }

    p {
      position: relative;
      z-index: 1;
      padding: 0 15/@rem;
      background-color: @mask;
    }
  }

  &-no-more {
    margin: 0 auto;
    color: @gray;
    line-height: 28/@rem;
    text-align: center;
  }
}

@keyframes rotate {
  from { transform: rotateZ(0deg); }
  to { transform: rotateZ(360deg); }
}
</style>
